// ======================================================================
// FILE:
// src/modules/service_crm/satisfaction/components/SatisfactionPagination.js
//
// MODULE: Service CRM
// FEATURE: Satisfaction Pagination
// ======================================================================

import React from "react";

export default function SatisfactionPagination({

  page,

  pageSize,

  total,

  onPageChange,

  onPageSizeChange,
}) {

  const totalPages = Math.max(
    1,
    Math.ceil(total / pageSize)
  );

  return (

    <div

      style={{

        background: "#fff",

        borderRadius: 14,

        padding: 16,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

        display: "flex",

        justifyContent:
          "space-between",

        alignItems: "center",

        flexWrap: "wrap",

        gap: 12,
      }}
    >

      {/* LEFT */}

      <div>

        Showing Page

        <strong>
          {" "}
          {page}
          {" "}
        </strong>

        of

        <strong>
          {" "}
          {totalPages}
          {" "}
        </strong>

        (
        {total}
        {" "}
        records
        )

      </div>

      {/* RIGHT */}

      <div

        style={{

          display: "flex",

          alignItems: "center",

          gap: 10,
        }}
      >

        <label>

          Page Size

        </label>

        <select

          value={pageSize}

          onChange={(e) =>
            onPageSizeChange(
              Number(
                e.target.value
              )
            )
          }

          style={{

            padding: "6px 10px",

            borderRadius: 6,

            border:
              "1px solid #ced4da",
          }}
        >

          <option value={10}>
            10
          </option>

          <option value={20}>
            20
          </option>

          <option value={50}>
            50
          </option>

          <option value={100}>
            100
          </option>

        </select>

        <button

          disabled={
            page <= 1
          }

          onClick={() =>
            onPageChange(
              page - 1
            )
          }

          style={buttonStyle}
        >
          Previous
        </button>

        <button

          disabled={
            page >= totalPages
          }

          onClick={() =>
            onPageChange(
              page + 1
            )
          }

          style={buttonStyle}
        >
          Next
        </button>

      </div>

    </div>
  );
}


// ======================================================================
// STYLES
// ======================================================================

const buttonStyle = {

  background: "#0d6efd",

  color: "#fff",

  border: "none",

  borderRadius: 6,

  padding: "8px 14px",

  cursor: "pointer",
};